import React from 'react'
import { connect } from 'react-redux'
import { fetchSubBandsIfNeeded } from '~/community/actions'
import { fetchNodeIfNeeded } from '~/nodes/actions'
import { Link } from 'react-router-dom'
import unescape from 'lodash/unescape';
const route = 'subscribers/bands/'
class SubBands extends React.Component{

  componentWillMount(){
    const { dispatch, match } = this.props
    if (match.params && match.params.id) {
      dispatch(fetchNodeIfNeeded('subscribers/bands/' + match.params.id))
      if (typeof(window) !== "undefined")
        window.scrollTo(0, 0)
    }
    dispatch(fetchSubBandsIfNeeded())
  }

  componentWillReceiveProps(nextProps) {
    const { dispatch, match } = this.props
    if(nextProps.match.params.id != match.params.id) {
      dispatch(fetchNodeIfNeeded('subscribers/bands/' + nextProps.match.params.id))
      if (typeof(window) !== "undefined")
        window.scrollTo(0, 0);
    }
  }

  static fetchData(store, route, match) {
    if(match.params.id) {
      return Promise.all([
        store. dispatch(fetchSubBandsIfNeeded()),
        store.dispatch(fetchNodeIfNeeded('subscribers/bands/' + match.params.id))
      ])

    }
    return Promise.all([
      store. dispatch(fetchSubBandsIfNeeded()),
    ])
  }

  render() {
    const { subBands, nodes, match } = this.props
    let band
    if (match.params.id) {
      let bandRoute = route + match.params.id
      if (nodes[bandRoute] && nodes[bandRoute].title )
        band = nodes[bandRoute]
    }

    return (
      <div id="bands">
        { band &&
          <div>
            <h1>{ band.title[0].value }</h1>
            <div className="sections">
            <div>{band.field_sub_band_logo.length > 0 && <img src={band.field_sub_band_logo[0].url} />}</div>
            <div>{band.field_sub_band_tag_line.length > 0 && <p><b>{band.field_sub_band_tag_line[0].value }</b></p>}
            <div dangerouslySetInnerHTML={{ __html: band.body[0].value }} />
            {band.field_sub_band_link.length > 0 && <p><a href={band.field_sub_band_link[0].uri} target="_blank" >{band.field_sub_band_link[0].uri}</a></p>}</div>
            </div>
          </div>
        }
        <h2>4ZZZ Band & Musician Subscribers</h2>
        <div className="sub-bands">
          { subBands.items.map((item, index) => (
            <div key={index} className="band">
              <Link to={item.view_node}>
                {item.field_sub_band_logo.length > 0 ? <img src={'//jeff.4zzz.org.au' + item.field_sub_band_logo} /> : <img style={{ width: '220px', height: '220px' }} src="/assets/no-image.svg" />}
                <h3>{ unescape(item.title) }</h3>
                {item.field_sub_band_tag_line.length > 0 && <p><b>{item.field_sub_band_tag_line}</b></p>}
              </Link>
            </div>
          ))}
        </div>

      </div>
    )

    /*return (
      <div>
      { subBands.items.map((item, index) => (
        <div>
          <h3>{ item.title[0].value }</h3>
          {item.field_sub_band_logo.length > 0 && <img src={item.field_sub_band_logo[0].url} />}
          {item.field_sub_band_tag_line.length > 0 && <p><b>{item.field_sub_band_tag_line[0].value }</b></p>}
          <div dangerouslySetInnerHTML={{ __html: item.body[0].value }} />
          {item.field_sub_band_link.length > 0 && <p><a href={item.field_sub_band_link[0].uri} target="_blank" >{item.field_sub_band_link[0].uri}</a></p>}
          {item.field_sub_band_expiry_date.length > 0 && <p>{item.field_sub_band_expiry_date[0].value }</p>}
        </div>
      ))}
      </div>
    )*/
  }
}
export default connect(state => ( { subBands: state.subBands, nodes: state.nodes  })) (SubBands)
